namespace Nobox.CRM {
    export interface DealsRow {
        Id?: number;
        Nm?: string;
        CryId?: string;
        Prc?: number;
        ClsDt?: string;
        SrcId?: number;
        Src?: string;
        LostRId?: number;
        IsDone?: number;
        LostR?: string;
        PlId?: number;
        piplinetypes?: number;
        PlTags?: string;
        StDt?: string;
        ExpDt?: string;
        PriorityId?: DealPriorityEnum;
        GrpId?: number;
        Grp?: string;
        CtIds?: string;
        PdtIds?: string;
        Assign?: number;
        Index?: number;
        InBy?: number;
        In?: string;
        UpBy?: number;
        Up?: string;
        Comments?: DealcommentsRow[];
        Pdt?: string;
        CtDeal?: DealcontactsRow[];
        Pdts?: ProductdealsRow[];
    }

    export namespace DealsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Nm';
        export const localTextPrefix = 'Nobox.Deals';
        export const lookupKey = 'Nobox.Deals';

        export function getLookup(): Q.Lookup<DealsRow> {
            return Q.getLookup<DealsRow>('Nobox.Deals');
        }
        export const deletePermission = 'Deals:Delete';
        export const insertPermission = 'Deals:Modify';
        export const readPermission = 'Deals:View';
        export const updatePermission = 'Deals:Modify';

        export declare const enum Fields {
            Id = "Id",
            Nm = "Nm",
            CryId = "CryId",
            Prc = "Prc",
            ClsDt = "ClsDt",
            SrcId = "SrcId",
            Src = "Src",
            LostRId = "LostRId",
            IsDone = "IsDone",
            LostR = "LostR",
            PlId = "PlId",
            piplinetypes = "piplinetypes",
            PlTags = "PlTags",
            StDt = "StDt",
            ExpDt = "ExpDt",
            PriorityId = "PriorityId",
            GrpId = "GrpId",
            Grp = "Grp",
            CtIds = "CtIds",
            PdtIds = "PdtIds",
            Assign = "Assign",
            Index = "Index",
            InBy = "InBy",
            In = "In",
            UpBy = "UpBy",
            Up = "Up",
            Comments = "Comments",
            Pdt = "Pdt",
            CtDeal = "CtDeal",
            Pdts = "Pdts"
        }
    }
}
